import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "brockerageIpfsDetails",
  initialState: {
    IpfsDetailsList: [],
    isbrokerageIpfsDetailModalOpen: false,
    detailsProvider: {},
    isAddingProvider: false,
    isAddedProvider: false,
    ipfsDetails: {},
    gettingMyRemindersSuccess: false,
    allIpfsDetailsList: [],
    ipfsFailedMessage: null,
    isDeleted: false,
    toastSuccessMessage: {},
  },

  reducers: {
    allPaymentProviderSuccess: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.IpfsDetailsList =
        action.payload?.paymentMethodTypesDetails;
    },
    brokeragesReceived: (brokerages, action) => {
      brokerages.list = action.payload;
    },
    brockerageIpfsDetailsModalOpened: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.toastSuccessMessage = {};
      brockerageIpfsDetails.ipfsFailedMessage = null;
      brockerageIpfsDetails.isDeleted = false;
      brockerageIpfsDetails.isbrokerageIpfsDetailModalOpen = true;
    },
    brockerageIpfsDetailsModalClosed: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.isbrokerageIpfsDetailModalOpen = false;
    },
    updatePaymentProvider: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.detailsProvider = action.payload;
    },
    paymentProviderNull: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.detailsProvider = {};
    },
    addedNewProvider: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.isAddingProvider = false;
      brockerageIpfsDetails.ipfsDetails = action.payload;
      brockerageIpfsDetails.isAddedProvider = true;
      brockerageIpfsDetails.toastSuccessMessage = action.payload;
    },
    addingNewProvider: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.isAddingProvider = true;
    },
    addedNewProviderFailed: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.ipfsFailedMessage = action.payload;
      brockerageIpfsDetails.isDeleted = true;
    },
    allIpfsDetailsSuccess: (brockerageIpfsDetails, action) => {
      brockerageIpfsDetails.allIpfsDetailsList = action.payload?.data;
    },
  },
});

export const {
  paymentProviderNull,
  allPaymentProviderSuccess,
  brokeragesReceived,
  brockerageIpfsDetailsModalOpened,
  brockerageIpfsDetailsModalClosed,
  updatePaymentProvider,
  addingNewProvider,
  addedNewProvider,
  allIpfsDetailsSuccess,
  addedNewProviderFailed,
} = slice.actions;

export default slice.reducer;

// action creator

export const getAllPaymentProvider = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/custom-payment-method",
    method: "get",
    onSuccess: allPaymentProviderSuccess.type,
  });

export const loadBrokerages = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages",
    method: "get",
    data: data,
    onSuccess: brokeragesReceived.type,
  });

export const addNewIpfsDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs",
    method: "post",
    data: data,
    onStart: addingNewProvider.type,
    onSuccess: addedNewProvider.type,
    onError: addedNewProviderFailed.type,
  });

export const getAllIpfsDetails = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs",
    method: "get",
    onSuccess: allIpfsDetailsSuccess.type,
  });

export const getPaymentProviders = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.IpfsDetailsList
);

export const getBrokeragesList = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.list
);

export const getBrokerageIpfsDetailsModalOpen = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) =>
    brockerageIpfsDetails.isbrokerageIpfsDetailModalOpen
);

export const getUpdateProvider = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.detailsProvider
);

export const getIpfsAllDetailProvider = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.allIpfsDetailsList
);

export const getIpfsFailed = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.ipfsFailedMessage
);
export const isIpfsFailed = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.isDeleted
);

export const isAddedBrokerageProvider = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.isAddedProvider
);
export const getSuccessMessage = createSelector(
  (state) => state.entities.brockerageIpfsDetails,
  (brockerageIpfsDetails) => brockerageIpfsDetails.toastSuccessMessage
);
